import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useBiLogger} from '../../components/BiProvider/withBiLogger';
import {TrackInfo} from '../../components/TrackInfo/TrackInfo';
import {Animation} from '../../components/ui/Animation';
import {FADE_IN_UP} from '../../components/ui/TransitionsBehavior';
import {isBuy, isNameYourPrice} from '../../services/albumProvider/albumProvider';
import {BI_SCHEMA} from '../../services/biLogger/biEvents';
import {getAlbumAction, getTrackAction} from '../../store/actions';
import {albumSelector, trackSelector} from '../../store/selectors';
import styles from './TrackInfoContainer.scss';
import {IOuter} from './TrackInfoContainer.types';

export const TrackInfoContainer: React.FunctionComponent<IOuter> = () => {
  const album = useSelector(albumSelector);
  const track = useSelector(trackSelector);
  const biLogger = useBiLogger();
  const dispatch = useDispatch();
  function handleGetAlbumButtonClick() {
    if (isBuy(album) || isNameYourPrice(album)) {
      biLogger.log(BI_SCHEMA.player.album.purchase.clicked, {
        price: Math.round(Number(album.albumPrice) * 10000),
        currency: album.albumCurrency,
        origin: 'downloadPage',
        sendToDownloadPage: true,
      });
    }
    dispatch(getAlbumAction());
  }

  function handleGetTrackButtonClick() {
    if (isBuy(track) || isNameYourPrice(track)) {
      biLogger.log(BI_SCHEMA.player.track.purchase.clicked, {
        price: Math.round(Number(track.trackPrice) * 10000),
        currency: album.albumCurrency,
        origin: 'downloadPage',
        trackID: track.id,
        trackIdxInAlbum: album.tracks.map((track) => track.id).indexOf(track.id) + 1,
        sendToDownloadPage: true,
      });
    }
    dispatch(getTrackAction({track}));
  }

  return (
    <Animation
      className={styles.trackInfoContainer}
      wrapperClassName={styles.trackInfoContainerWrapper}
      motions={FADE_IN_UP}
      animationKey={'TRACK_INFO' + track.id}
    >
      <TrackInfo
        album={album}
        track={track}
        onGetAlbumButtonClick={handleGetAlbumButtonClick}
        onGetTrackButtonClick={handleGetTrackButtonClick}
      />
    </Animation>
  );
};

TrackInfoContainer.displayName = 'TrackInfoContainer';
